import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CertificationApi } from 'api';

import { RootState } from '../app';

export const findCertification = createAsyncThunk(
  'certification/findCertification',
  async (_, { rejectWithValue }) => {
    try {
      const response = await CertificationApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
}

const initialState: IState = {
  list: [],
};

const certificationSlice = createSlice({
  name: 'certification',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findCertification.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: certificationReducer } = certificationSlice;

export default certificationReducer;

export const selectCertification = (state: RootState): IState =>
  state.certification as IState;
